// extracted by mini-css-extract-plugin
module.exports = {"compact":"WidgetPreview_compact__2QamW","mobile":"WidgetPreview_mobile__2Nlhl","body":"WidgetPreview_body__1Sz_m","note":"WidgetPreview_note__BsPEA"};